// @ts-check

/**
 * @module files/CourseFile
 */

import { fileErrors } from './validation';

/** Class representing a course file */
export default class CourseFile {
    /**
     * Create a CourseFile
     * @param {Object} params
     * @param {string} params.name
     * @param {number} params.elementId
     * @param {string} params.cloudId
     * @param {boolean} params.success
     * @param {string} params.error
     * @param {Object} [params.fileRepoFile=undefined] - source file repo file from FilePicker
     * @param {Object} [params.cloudFile=undefined] - source cloud file from FilePicker
     */
    constructor({ name, elementId, cloudId, success, error, fileRepoFile, cloudFile }) {
        this.name = name;
        this.elementId = elementId;
        this.cloudId = cloudId;
        this.success = success;
        this.error = error;
        this.fileRepoFile = fileRepoFile;
        this.cloudFile = cloudFile;
    }

    /**
     * Create a CourseFile from an api response
     * @param {Object} file
     * @param {string} file.Title
     * @param {number} file.ElementId
     * @param {string} file.CloudId
     * @param {boolean} file.Success
     * @param {number[]} file.ErrorCodes
     */
    static fromApi(file) {
        const result = new CourseFile({
            name: file.Title,
            elementId: file.ElementId,
            cloudId: file.CloudId,
            success: file.Success,
            error: undefined,
        });

        if (!file.Success) {
            const errorCode = file.ErrorCodes && file.ErrorCodes.length ? file.ErrorCodes[0] : undefined;

            const errorName = {
                1: fileErrors.invalidExtension, // InvalidFileExtension
                2: fileErrors.invalidFileName, // InvalidUploadedContent
                3: fileErrors.tooLarge, // FileSizeIsTooBig
                10: fileErrors.invalidFileName, // FileNameContainsInvalidCharacters
                11: fileErrors.invalidFileName, // IllegalFirstPartOfFileName
                14: fileErrors.nameTooLong, // FileNameTooLong
                17: fileErrors.invalidFileType, // InvalidElementType
                28: fileErrors.invalidFileType, // InvalidFile
            }[errorCode];

            result.error = errorName === undefined ? fileErrors.unknown : errorName;
        }

        return result;
    }
};
